import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestLogin = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/transfer/login',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestTransfer = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/transfer/point',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestLogin,
  requestTransfer,
};
